export const ORIGIN = "https://insights.cryptember.com";
export const KEY = "XbNjQPPkT9wSllpWr1";